import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import makeStyles from '@mui/styles/makeStyles';

import { TilesLabel } from 'ui/Labels';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2, 5),
  },
  items: {
    margin: theme.spacing(0, -2, -2),
  },
}));

const CompanyBasicData = ({ items }) => {
  const classes = useStyles();

  return (
    <Grid container direction="row" alignItems="center" className={classes.container}>
      <Grid container className={classes.items}>
        {items
          .filter(({ value }) => value && value !== '-')
          .map(
            ({ label, value, onClick }) =>
              label &&
              value && (
                <Grid item xs={2.4} key={label}>
                  <TilesLabel label={label} value={value} onClick={onClick} />
                </Grid>
              ),
          )}
      </Grid>
    </Grid>
  );
};

CompanyBasicData.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      onClick: PropTypes.func,
    }),
  ).isRequired,
};

export default CompanyBasicData;
